import React, { createContext, useState } from 'react';

const StateContext = createContext({
  state: {
    theme: 'static',  // static | dynamic
    isModalOpen: true,
    allMedia: [],
  },
  setTheme: () => { },
});

const StateProvider = ({ children }) => {
  const [state, setState] = useState({ theme: 'static', isModalOpen: true, allMedia: [] });
  const updateState = (state) => {
    setState(state);
  };

  return (
    <StateContext.Provider
      value={{
        state,
        updateState
      }}
    >
      {children}
    </StateContext.Provider>
  );

}

export default StateContext;

export { StateProvider };
